/* BMC Landing TOBY — bmc-landing.js (2026-07-26) with TWO changes: (1) the funnel
   zero-list is read from the offer form's data-zero attribute instead of being
   hard-coded, so the Toby Fox landing page can never delete another funnel's cart
   lines; (2) drawer bumps accept showIfCountry / hideIfCountry, resolved from
   Shopify's geolocation endpoint (Dan 2026-09-17). Everything else (capture-phase
   buy, the app's cart drawer + injected bumps, sticky bar, popup guard) is the same. */
/* BMC Landing — progressive enhancement (loaded with data-cfasync="false").
   1) Running total + checkbox visuals + enable the community subscription plan
      only when its box is ticked.
   2) CART FIX: a store app globally hijacks native /cart/add form submits and
      chokes on multi-item items[], so the button did nothing. We take the click
      in the CAPTURE phase + stopImmediatePropagation (beats the app), then do the
      proven /cart/add.js AJAX add and redirect to /cart. window.__bmcLP marks that
      it ran.
   3) CART DRAWER (Dan 2026-07-26): every #bmc-lp-buy CTA adds the main item through
      that same app's window.monster_addToCart(), which opens its own proven drawer,
      and we inject one add-on card into that drawer. See the CART DRAWER section. */
(function () {
  window.__bmcLP = true;
  var form = document.getElementById('bmc-lp-form');
  if (!form) return;

  // ---- A/B test plumbing (Dan 2026-07-20) ----
  // Arm comes from the splitter cookie (see bmc-landing[-b].liquid). Beacons go
  // to the hub's public ab collector; sendBeacon so the ATC ping survives the
  // redirect to /cart. text/plain body on purpose: no CORS preflight.
  // Hub beacons are OFF for this test on purpose: bmc-hub's /api/ingest/ab and
  // its readout are single-test (blueprint-start, started 2026-07-20) and count
  // every lpv/atc beacon and every note_attributes.bmc_ab order. Sending from
  // here would contaminate that ledger. This test stamps its own cart attribute
  // (bmc_ab_toby) and its own cookie; read arms from Shopify orders / HYROS.
  var AB_HUB = '';
  function abArm() {
    // Cookie first, localStorage as the survivor copy (Safari caps script
    // cookies at 7 days); whichever exists restores the other.
    var m = document.cookie.match(/(?:^|; )bmc_ab_toby=(a|b)/);
    if (m) return m[1];
    try {
      var ls = window.localStorage.getItem('bmc_ab_toby');
      if (ls === 'a' || ls === 'b') {
        document.cookie = 'bmc_ab_toby=' + ls + '; path=/; max-age=2592000; SameSite=Lax';
        return ls;
      }
    } catch (e) {}
    return null;
  }
  // The arm the visitor is LOOKING AT, read from the rendered markup, never
  // the URL. If the B template ever goes missing, ?view=bmc-landing-b falls
  // back to rendering arm A; a URL check would then count A-experiences as B
  // silently. Markup can't lie about what rendered.
  var lpRoot = form.closest('[data-ab-arm]');
  var pageArm = lpRoot ? lpRoot.getAttribute('data-ab-arm') : null;
  function abSend(kind) {
    if (!AB_HUB) return;
    var arm = pageArm || abArm();
    if (!arm) return;
    try {
      var id = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : String(Date.now()) + '-' + Math.floor(Math.random() * 1e9);
      var body = JSON.stringify({ a: arm, k: kind, u: location.href.slice(0, 1024), id: id });
      if (navigator.sendBeacon) navigator.sendBeacon(AB_HUB, new Blob([body], { type: 'text/plain' }));
      else fetch(AB_HUB, { method: 'POST', body: body, keepalive: true }).catch(function () {});
    } catch (e) {}
  }
  // Landing view: count only when the visitor is on their OWN arm's page (a
  // b-assigned visitor mid-redirect on the A page must not count twice).
  if (pageArm && abArm() === pageArm) abSend('lpv');
  var base = parseInt(form.getAttribute('data-base'), 10) || 0;
  var addon = parseInt(form.getAttribute('data-addon'), 10) || 0;
  var totalEl = document.getElementById('bmc-lp-total');
  var subEl = document.getElementById('bmc-lp-total-sub');
  var addonBox = form.querySelector('[data-opt="addon"] input[type=checkbox]');
  var commBox = form.querySelector('[data-opt="community"] input[type=checkbox]');
  var commPlan = form.querySelector('[data-sibling="community"]');
  var btn = form.querySelector('button[type=submit]');
  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); }

  function sync() {
    var opts = form.querySelectorAll('.bmc-lp-opt');
    for (var i = 0; i < opts.length; i++) {
      var c = opts[i].querySelector('input[type=checkbox]');
      if (c) { if (c.checked) opts[i].classList.add('is-on'); else opts[i].classList.remove('is-on'); }
    }
    var t = base + (addonBox && addonBox.checked ? addon : 0);
    if (totalEl) totalEl.textContent = money(t);
    if (commPlan) commPlan.disabled = !(commBox && commBox.checked);
    if (subEl) subEl.textContent = (commBox && commBox.checked) ? '+ $49/month' : '';
  }
  form.addEventListener('change', sync);
  sync();

  // ---- CART FIX: own the buy click, do the proven AJAX add, then open /cart ----
  // Every funnel variant across BOTH landing pages. On each buy we zero all of them
  // then add back only the current selection at qty 1, so re-clicking (or leaving and
  // returning) can never stack duplicates: one of each, max, on both pages.
  // bmc-landing-toby.js: the zero-list comes from the form's data-zero attribute
  // (a JSON array of variant ids rendered by the section), so this page only ever
  // clears its OWN funnel lines and never touches another funnel's cart items.
  var FUNNEL_VARIANTS = [];
  try {
    var zeroRaw = form.getAttribute('data-zero');
    if (zeroRaw) FUNNEL_VARIANTS = JSON.parse(zeroRaw).map(String).filter(function (v) { return v && v !== 'null' && v !== 'undefined'; });
  } catch (e) { FUNNEL_VARIANTS = []; }
  if (!FUNNEL_VARIANTS.length) {
    var mainSeed = form.querySelector('input[name="items[0][id]"]');
    if (mainSeed && mainSeed.value) FUNNEL_VARIANTS = [String(mainSeed.value)];
  }

  // Shipping Protection $2.99. KEPT ON PURPOSE (Dan 2026-07-26): physical products
  // are coming and this is $3 of pure margin on any order that actually ships. It is
  // NOT in FUNNEL_VARIANTS, so a funnel buy never silently deletes it. It is only
  // dropped, and its app upsell only hidden, when the cart contains nothing that
  // ships — on a digital-only order "replaces lost, stolen, damaged orders" is not
  // a true statement about a course delivered by email.
  var SHIP_PROTECT = '45140585971862';

  var POST = { method: 'POST', credentials: 'same-origin',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' } };

  var adding = false;
  function addToCart(e) {
    if (e) { e.preventDefault(); e.stopImmediatePropagation(); }
    if (adding) return;
    adding = true;
    sync();
    var mainInput = form.querySelector('input[name="items[0][id]"]');
    var mainId = mainInput ? mainInput.value : null;
    var wantAddon = !!(addonBox && addonBox.checked);
    var wantComm = !!(commBox && commBox.checked);
    var addonId = addonBox ? addonBox.value : null;
    var commId = commBox ? commBox.value : null;
    var commPlanVal = commPlan ? commPlan.value : null;
    var label = btn ? btn.textContent : '';
    if (btn) { btn.setAttribute('disabled', 'disabled'); btn.textContent = 'Adding to cart...'; }

    function fail() { adding = false; if (btn) { btn.removeAttribute('disabled'); btn.textContent = label; } }

    // 1) clear every funnel variant (removes any stacked duplicates first)
    var clr = new URLSearchParams();
    FUNNEL_VARIANTS.forEach(function (id) { clr.append('updates[' + id + ']', '0'); });
    // Stamp the A/B arm as a cart attribute: Shopify carries it onto the order
    // as a note_attribute, which is how the hub splits purchases per arm.
    // Stamp the arm the buyer SAW (markup), falling back to the assignment.
    var armNow = pageArm || abArm();
    if (armNow) clr.append('attributes[bmc_ab_toby]', armNow);
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' }, body: clr.toString(), credentials: 'same-origin' })
      .then(function () {
        // 2) add exactly the current selection at qty 1
        var p = new URLSearchParams();
        p.append('items[0][id]', mainId); p.append('items[0][quantity]', '1');
        var n = 1;
        if (wantAddon && addonId) { p.append('items[' + n + '][id]', addonId); p.append('items[' + n + '][quantity]', '1'); n++; }
        if (wantComm && commId) { p.append('items[' + n + '][id]', commId); p.append('items[' + n + '][quantity]', '1'); if (commPlanVal) p.append('items[' + n + '][selling_plan]', commPlanVal); n++; }
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' }, body: p.toString(), credentials: 'same-origin' });
      })
      .then(function (r) { if (r && r.ok) { abSend('atc'); window.location.href = '/cart'; return; } fail(); })
      .catch(fail);
  }
  if (btn) btn.addEventListener('click', addToCart, true); // capture: run before the app's handler
  form.addEventListener('submit', addToCart, true);        // Enter-key path

  // ---- Sticky bottom bar: only show BETWEEN the hero CTA and the offer block ----
  // Hidden while the hero CTA is on screen (it would overlap it on short screens)
  // AND hidden while the offer block is on screen. At the offer, the bar's anchor
  // button sat next to the real submit and clicking it just re-scrolled to the same
  // section — that read as "the button loops back to the selection page" (Dan
  // 2026-07-18). One green button at a time: at the offer, the submit is the button.
  var stickyBar = document.querySelector('.bmc-lp-bar');
  var heroCta = document.querySelector('.bmc-lp-intro__ctawrap');
  var offerForm = document.getElementById('bmc-lp-form') || document.getElementById('bmc-lp-buy');
  if (stickyBar && heroCta) {
    stickyBar.style.transition = 'transform .18s ease, opacity .18s ease';
    var setBar = function (show) {
      stickyBar.style.transform = show ? 'translateY(0)' : 'translateY(115%)';
      stickyBar.style.opacity = show ? '1' : '0';
      stickyBar.style.pointerEvents = show ? 'auto' : 'none';
    };
    // Plain scroll + geometry, NOT IntersectionObserver: an app on this store
    // breaks IO globally (fresh observers never fire even their initial
    // callback), which froze the bar. rAF-throttled rect checks can't be
    // sabotaged. Bar shows only between the hero CTA and the offer form, so
    // there is never a second green button next to the real one (Dan 07-18).
    var vis = function (el) {
      if (!el) return false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var r = el.getBoundingClientRect();
      return r.bottom > 0 && r.top < vh;
    };
    var evalBar = function () { setBar(!vis(heroCta) && !vis(offerForm)); };
    var pend = false;
    var onMove = function () {
      if (pend) return;
      pend = true;
      requestAnimationFrame(function () { pend = false; evalBar(); });
    };
    window.addEventListener('scroll', onMove, { passive: true });
    window.addEventListener('resize', onMove, { passive: true });
    evalBar();
  }

  // Single-path funnel: repoint any /cart or /checkout link inside the ported sales
  // copy to the offer block so every CTA flows through the add-on-aware form.
  // The pop-out is exempt: its Checkout link really does mean /checkout.
  var links = document.querySelectorAll('.bmc-lp a[href*="/cart"], .bmc-lp a[href*="/checkout"]');
  for (var j = 0; j < links.length; j++) {
    var a = links[j];
    if (a.closest('#bmc-lp-form') || a.closest('.bmc-lp-bar') || a.getAttribute('href').charAt(0) === '#') continue;
    a.setAttribute('href', '#bmc-lp-buy');
    a.removeAttribute('target');
  }

  // ---- CART DRAWER: drive the app's own drawer, put our add-on inside it ------
  // Dan 2026-07-26: "I need the original design of the cart... and then to have that
  // upsell in there as well." That drawer belongs to the Monster Upsell app, so we do
  // NOT rebuild it. The app exposes window.monster_addToCart({items:[...]}) which adds
  // AND opens the drawer already hydrated, plus window.monster_refresh(). We add the
  // main item through that call and inject one offer card into the drawer's DOM.
  // The drawer is a React tree that re-renders on every cart change, so a
  // MutationObserver puts the card back after each render.
  var offerCfg = null;
  try {
    var cfgEl = document.getElementById('bmc-drawer-offer-data');
    if (cfgEl) offerCfg = JSON.parse(cfgEl.textContent);
  } catch (e) {}

  // ---- LAUNCH SPRINT CODE (Dan 2026-09-17) ----------------------------------
  // The product is $100 and code LAUNCH51 takes $51 off. Ads and emails tell people
  // to type it at checkout, but nobody should pay $100 because they forgot to, so
  // we plant the code in Shopify's own session once per browser session. The
  // /discount/<code> route is Shopify's, the redirect keeps the response tiny, and
  // the code is scoped to this product so it cannot discount a bump by accident.
  function applySprintCode(code) {
    if (!code) return;
    var key = 'bmc_sprint_' + code;
    try { if (window.sessionStorage.getItem(key)) return; } catch (e) {}
    fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', { credentials: 'same-origin' })
      .then(function () { try { window.sessionStorage.setItem(key, '1'); } catch (e) {} })
      .catch(function () {});
  }
  if (offerCfg && offerCfg.sprintCode) applySprintCode(offerCfg.sprintCode);

  function muAdd(items) {
    if (typeof window.monster_addToCart === 'function') {
      try { return Promise.resolve(window.monster_addToCart({ items: items })); } catch (e) {}
    }
    // app missing or broken: fall back to the proven AJAX add + the real cart page,
    // so the buy path still works rather than dead-ending on a silent failure.
    var p = new URLSearchParams();
    items.forEach(function (it, i) {
      p.append('items[' + i + '][id]', it.id);
      p.append('items[' + i + '][quantity]', it.quantity);
    });
    return fetch('/cart/add.js', Object.assign({ body: p.toString() }, POST))
      .then(function () { window.location.href = '/cart'; });
  }
  // A subscription bump (community) carries "sellingPlan". Shopify only makes the
  // line recurring when selling_plan rides along on /cart/add, and the upsell app's
  // monster_addToCart({items:[{id,quantity}]}) has nowhere to put it, so those rows
  // go through the native cart API and then ask the app to re-render its drawer.
  // Plain bumps keep the proven app path.
  function addBump(b) {
    if (!b.sellingPlan) return muAdd([{ id: Number(b.variant), quantity: 1 }]);
    var p = new URLSearchParams();
    p.append('items[0][id]', b.variant);
    p.append('items[0][quantity]', 1);
    p.append('items[0][selling_plan]', b.sellingPlan);
    return fetch('/cart/add.js', Object.assign({ body: p.toString() }, POST))
      .then(muRefresh);
  }
  function muRefresh() {
    if (typeof window.monster_refresh === 'function') {
      try { return Promise.resolve(window.monster_refresh()); } catch (e) {}
    }
    return Promise.resolve();
  }

  var offerBusy = false;

  function bumpRow(b) {
    var li = document.createElement('li');
    li.className = 'bmc-do__item';
    li.setAttribute('data-variant', b.variant);
    li.innerHTML =
      '<img class="bmc-do__img" width="44" height="44" loading="lazy">' +
      '<span class="bmc-do__copy"><span class="bmc-do__t"></span><span class="bmc-do__d"></span></span>' +
      '<button type="button" class="bmc-do__btn"></button>';
    // textContent only: nothing from the config blob can inject markup
    li.querySelector('.bmc-do__t').textContent = b.title;
    li.querySelector('.bmc-do__d').textContent = b.blurb;
    var img = li.querySelector('.bmc-do__img');
    img.src = b.img; img.alt = b.title;
    li.querySelector('.bmc-do__btn').addEventListener('click', function () { toggleBump(b); });
    return li;
  }

  function buildOfferBlock() {
    var el = document.createElement('div');
    el.id = 'bmc-drawer-offer';
    var h = document.createElement('p');
    h.className = 'bmc-do__kicker';
    h.textContent = offerCfg.heading || 'Add to your order';
    var ul = document.createElement('ul');
    ul.className = 'bmc-do__list';
    offerCfg.bumps.forEach(function (b) { ul.appendChild(bumpRow(b)); });
    el.appendChild(h); el.appendChild(ul);
    return el;
  }

  // ---- Visitor country (Dan 2026-09-17): a bump can be limited to countries ----
  // Shopify's own geolocation endpoint (the one its Geolocation app and the Markets
  // redirect use) tells us the country it detects from the visitor's IP. One call per
  // browser session, cached in sessionStorage. Unknown country = nothing is hidden, so
  // a blocked request can never hide a bump from a US buyer.
  var GEO_KEY = 'bmc_geo_country';
  var geoCountry = '';
  function visitorCountry() {
    try { var c = window.sessionStorage.getItem(GEO_KEY); if (c) return Promise.resolve(c === '??' ? '' : c); } catch (e) {}
    return fetch('/browsing_context_suggestions.json?source=geolocation_recommendation', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var code = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
        code = code ? String(code).toUpperCase() : '';
        try { window.sessionStorage.setItem(GEO_KEY, code || '??'); } catch (e) {}
        return code;
      })
      .catch(function () { return ''; });
  }
  function countryAllows(b) {
    if (!geoCountry) return true;
    if (b.showIfCountry && b.showIfCountry.length && b.showIfCountry.indexOf(geoCountry) < 0) return false;
    if (b.hideIfCountry && b.hideIfCountry.length && b.hideIfCountry.indexOf(geoCountry) >= 0) return false;
    return true;
  }

  // A bump shows only when the cart already holds one of its showIfCartHas entries
  // (SKU or raw variant id). Empty list = always. Anything already in the cart stays
  // on screen as a Remove control so the shopper can undo it. showIfCountry /
  // hideIfCountry (ISO codes) narrow that by the visitor's detected country.
  function bumpTriggered(b, skus, vids) {
    var trig = b.showIfCartHas || [];
    if (!trig.length) return true;
    for (var i = 0; i < trig.length; i++) {
      var t = String(trig[i]);
      if (skus[t] || vids[t]) return true;
    }
    return false;
  }

  function paintBumps(cart) {
    var block = document.getElementById('bmc-drawer-offer');
    if (!block || !cart || !cart.items) return;
    var skus = {}, vids = {};
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.sku) skus[it.sku] = true;
      vids[String(it.variant_id)] = true;
    }
    var shown = 0;
    offerCfg.bumps.forEach(function (b) {
      var row = block.querySelector('.bmc-do__item[data-variant="' + b.variant + '"]');
      if (!row) return;
      var inCart = !!(vids[String(b.variant)] || (b.sku && skus[b.sku]));
      var show = inCart || (bumpTriggered(b, skus, vids) && countryAllows(b));
      row.hidden = !show;
      if (show) shown++;
      if (inCart) row.classList.add('is-on'); else row.classList.remove('is-on');
      var btn = row.querySelector('.bmc-do__btn');
      btn.textContent = inCart ? 'Added' : '+' + money(b.price) + (b.priceSuffix || '');
      btn.setAttribute('aria-label', (inCart ? 'Remove ' : 'Add ') + b.title);
    });
    // no bump qualifies for this cart: hide the whole block, heading included
    block.hidden = shown === 0;
  }

  // One cart read that does three jobs: paint every bump's state, decide whether
  // anything in the cart actually ships (that gates the app's Shipping Protection
  // upsell), and clear a protection line stranded on an all-digital cart.
  function refreshCartState() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items) return cart;
        var ships = false, orphanProtect = false;
        for (var i = 0; i < cart.items.length; i++) {
          var it = cart.items[i];
          if (String(it.variant_id) === SHIP_PROTECT) { orphanProtect = true; continue; }
          // LearnDash courses (SKU LD-<id>) never ship, whatever the variant says: the
          // Toby course is flagged "requires shipping" on purpose so checkout collects an
          // address and phone (2026-09-16), and that must not turn on the app's $2.99
          // Shipping Protection row for a course-only cart.
          if (it.requires_shipping && !/^LD-\d+$/.test(String(it.sku || ''))) ships = true;
        }
        var cl = document.documentElement.classList;
        if (ships) cl.add('bmc-cart-ships'); else cl.remove('bmc-cart-ships');
        if (offerCfg) paintBumps(cart);
        if (ships || !orphanProtect) return cart;
        var u = new URLSearchParams();
        u.append('updates[' + SHIP_PROTECT + ']', '0');
        return fetch('/cart/update.js', Object.assign({ body: u.toString() }, POST))
          .then(function (r) { return r.json(); })
          .catch(function () { return cart; });
      })
      .catch(function () { return null; });
  }

  function toggleBump(b) {
    if (offerBusy || !offerCfg) return;
    offerBusy = true;
    var block = document.getElementById('bmc-drawer-offer');
    var row = block && block.querySelector('.bmc-do__item[data-variant="' + b.variant + '"]');
    var btn = row && row.querySelector('.bmc-do__btn');
    var on = !!(row && row.classList.contains('is-on'));
    if (btn) btn.setAttribute('disabled', 'disabled');
    var after = function () {
      offerBusy = false;
      var again = document.querySelector('#bmc-drawer-offer .bmc-do__item[data-variant="' + b.variant + '"] .bmc-do__btn');
      if (again) again.removeAttribute('disabled');
    };
    if (on) {
      // change.js 400s on a bare variant id; update.js takes them and returns the cart
      var u = new URLSearchParams();
      u.append('updates[' + b.variant + ']', '0');
      fetch('/cart/update.js', Object.assign({ body: u.toString() }, POST))
        .then(muRefresh).then(refreshCartState).catch(function () {}).then(after);
    } else {
      addBump(b)
        .then(refreshCartState).catch(function () {}).then(after);
    }
  }

  // Put the block back after every re-render of the drawer. It goes in
  // #mu-checkout-container, the app's own upsell slot (where its Shipping Protection
  // offer sits), NOT under the cart items: that region is a fixed-height slider with
  // overflow:hidden and it cut the buttons off.
  function placeOfferCard() {
    if (!offerCfg) return;
    var host = document.getElementById('mu-checkout-container');
    if (!host) return;
    var block = document.getElementById('bmc-drawer-offer');
    if (!block) block = buildOfferBlock();
    var ocu = document.getElementById('mu-ocu-container');
    var want = (ocu && ocu.parentElement === host) ? ocu : host.firstChild;
    if (block.parentElement !== host || block.nextSibling !== want) host.insertBefore(block, want);
  }

  if (offerCfg && window.MutationObserver) {
    var moPending = false, wasOpen = false, lastItemsFp = null;
    new MutationObserver(function () {
      if (moPending) return;
      moPending = true;
      setTimeout(function () {
        moPending = false;
        placeOfferCard();
        var open = !!document.querySelector('#monster-cart-wrapper.mu_openned');
        // Re-read the cart when the drawer opens AND whenever its line items change.
        // Opening alone is not enough: the shopper can delete a line or change a
        // quantity with the app's own controls while the drawer stays open, and the
        // bump rules would then be judging a cart that no longer exists.
        // The fingerprint is the rendered item list, which paintBumps never touches,
        // so repainting cannot retrigger this and loop.
        // Fingerprint = the app's own rendered line items PLUS its checkout total.
        // Both are written by the app and never by us, so repainting the bumps cannot
        // change the fingerprint and loop. The total is included because a quantity
        // change can move the price without changing the item names.
        var itemsEl = document.getElementById('mu-items-container');
        var totalEl = document.getElementById('mu-checkout-button');
        var fp = (itemsEl ? itemsEl.textContent : '') + '|' + (totalEl ? totalEl.textContent : '');
        fp = fp.replace(/\s+/g, '');
        if (open && (!wasOpen || fp !== lastItemsFp)) {
          lastItemsFp = fp;
          refreshCartState();
        }
        wasOpen = open;
      }, 120);
    }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }
  placeOfferCard();
  refreshCartState();
  // resolve the country once, then repaint so country-limited rows settle
  visitorCountry().then(function (c) { geoCountry = c || ''; return refreshCartState(); });

  // Every #bmc-lp-buy CTA: clear the funnel variants, then add the main item through
  // the app so its drawer opens. Capture phase so the app's own global click handler
  // never sees it. Shipping Protection is deliberately NOT in FUNNEL_VARIANTS.
  var buying = false;
  function drawerBuy(e) {
    if (e) { e.preventDefault(); e.stopImmediatePropagation(); }
    if (buying) return;
    buying = true;
    var mainInput = form.querySelector('input[name="items[0][id]"]');
    var mainId = mainInput ? mainInput.value : null;
    if (!mainId) { buying = false; return; }
    var clr = new URLSearchParams();
    FUNNEL_VARIANTS.forEach(function (id) { clr.append('updates[' + id + ']', '0'); });
    var armNow = pageArm || abArm();
    if (armNow) clr.append('attributes[bmc_ab_toby]', armNow);
    fetch('/cart/update.js', Object.assign({ body: clr.toString() }, POST))
      .then(function () { abSend('atc'); return muAdd([{ id: Number(mainId), quantity: 1 }]); })
      .then(function () { placeOfferCard(); return refreshCartState(); })
      .catch(function () { window.location.href = '/cart'; })
      .then(function () { buying = false; });
  }
  // ONLY on pages that ship a drawer bump config (beginner). blueprint-start is mid
  // A/B test and is deliberately excluded from the drawer offer, so intercepting its
  // CTAs would take the shopper straight past its own offer block and silently drop
  // its "+$29 seamless loops" add-on. There, the anchor keeps its native behaviour:
  // scroll to the offer block, which is where that page's add-on and submit live.
  if (offerCfg) {
    document.addEventListener('click', function (e) {
      var t = e.target;
      var a = t && t.closest ? t.closest('a[href="#bmc-lp-buy"]') : null;
      if (!a) return;
      drawerBuy(e);
    }, true);
  }

  // ---- Block the 10% discount / email-signup popup on these landing pages ----
  // App-agnostic: hide known Klaviyo containers + any dynamically-shown fixed/absolute
  // overlay whose text mentions "10%". Never touches our own .bmc-lp UI, the cart, or
  // the ProveSource social-proof toast (it has no "10%").
  function hidePopupRoot(el) {
    var top = el, hop = 0;
    while (top.parentElement && hop < 6) { var ps = getComputedStyle(top.parentElement); if (ps.position === 'fixed' || ps.position === 'absolute') top = top.parentElement; hop++; }
    if (top.closest && top.closest('.bmc-lp')) return;
    top.style.setProperty('display', 'none', 'important');
  }
  function killPromoPopups() {
    try {
      var known = document.querySelectorAll('[class*="klaviyo-form"],[class*="kl-private-reset"],[class*="kl-teaser"],[id^="klaviyo"]');
      for (var i = 0; i < known.length; i++) { if (!known[i].closest('.bmc-lp')) known[i].style.setProperty('display', 'none', 'important'); }
      var all = document.querySelectorAll('div,section,aside,dialog,form');
      for (var k = 0; k < all.length; k++) {
        var el = all[k], st = getComputedStyle(el);
        if (st.position !== 'fixed' && st.position !== 'absolute') continue;
        if ((parseInt(st.zIndex, 10) || 0) < 50) continue;
        if (el.closest('.bmc-lp') || el.offsetHeight < 60) continue;
        if (/10\s*%|10\s*percent/i.test(el.textContent || '')) hidePopupRoot(el);
      }
      // popups usually lock scroll; keep the page usable
      document.documentElement.style.overflow = ''; if (document.body) document.body.style.overflow = '';
    } catch (e) {}
  }
  killPromoPopups();
  var kpN = 0, kpTimer = setInterval(function () { killPromoPopups(); if (++kpN > 45) clearInterval(kpTimer); }, 800); // watch ~36s
  if (window.MutationObserver) {
    var kpPending = false;
    new MutationObserver(function () { if (kpPending) return; kpPending = true; setTimeout(function () { kpPending = false; killPromoPopups(); }, 120); }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

